import { render, staticRenderFns } from "./CourseRelated.vue?vue&type=template&id=37990dec&scoped=true&"
import script from "./CourseRelated.vue?vue&type=script&lang=js&"
export * from "./CourseRelated.vue?vue&type=script&lang=js&"
import style0 from "./CourseRelated.vue?vue&type=style&index=0&id=37990dec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37990dec",
  null
  
)

export default component.exports